import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/element'
import 'animate.css' // 4.x的版本
import animateM from 'v-animate-m'
import '@/assets/css/trantion.css'
import '@/assets/css/global.css'
import '@/assets/fonts/iconfont.css'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VueQuillEditor from 'vue-quill-editor'
import Axios from 'axios'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import VueParticles from 'vue-particles'

import config from '@/config';


Vue.prototype.$returnItemValue = (list, value, labelName = 'label', valueName = 'value') => {
    let item = list.find(el => el[valueName] === value) || {}
    return item[labelName] || ''
}

Vue.prototype.$ReturnImgUrl = function(img) {
    var str = new RegExp("http");
    if (str.test(img)) {
        return img
    } else {
        return config.imgBaseUrl + img
    }
}

import { Message } from 'element-ui'

Vue.prototype.$beforeUploadImage = function(file) {
    const fileType = ['image/jpeg', 'image/jpg', 'image/png']
    const isType = fileType.indexOf(file.type) > -1;
    const isLtM = file.size / 1024 / 1024 < 10;

    if (!isType) {
        Message.error('上传失败，仅支持PNG/JPG格式');
    }

    if (!isLtM) {
        Message.error('上传文件大小不能超过 10MB!');
    }

    return isType && isLtM;
}

Vue.prototype.$beforeUploadVideo = function(file) {
    const fileType = ['video/mpeg', 'video/mp4', 'video/x-msvideo']
    const isType = fileType.indexOf(file.type) > -1;
    const isLtM = file.size / 1024 / 1024 < 100;

    if (!isType) {
        Message.error('上传失败，仅支持MP3/MP4/AVI格式');
    }

    if (!isLtM) {
        Message.error('上传文件大小不能超过 100MB!');
    }

    return isType && isLtM;
}

Vue.use(VideoPlayer)
// 将axios挂载到原型上
Vue.prototype.$axios = Axios
Vue.use(VueParticles)
Vue.use(VueQuillEditor)
Vue.use(VXETable)
Vue.use(animateM)
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')